import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { BsModalService } from "ngx-bootstrap/modal";

import { ModuleComponent } from '../module.component';
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";


@Component({
  templateUrl: './1B.component.html',
  styleUrls: ['../component.css']
})
export class _1BComponent extends ModuleComponent {

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "B11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about different ways to explore training programs.`
    });
    this.titles.push({
      "activityId": "B12",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Search</strong> Training Programs`
    });
    this.titles.push({
      "activityId": "B21",
      "html": `<i class="fas fa-file-import"></i> <strong>Consider</strong> the following when ranking your training program options`
    });
    this.titles.push({
      "activityId": "B22",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Review</strong> your bookmarked training programs.`
    });
    this.titles.push({
      "activityId": "B31",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about ways to pay for training and the college financial aid process`
    });
    this.titles.push({
      "activityId": "B32",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Make a plan to pay for training and to support yourself while you are in training."`
    });
    this.titles.push({
      "activityId": "B41",
      "html": `<i class="fas fa-mouse-pointer"></i> Test your knowledge`
    });


    this.group = 0;
    this.alpha = 'B';

    this.activeMod = { group: 0, alpha: 'B', number: 1 };
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    this.loadGuide();
  }

}
